
export const smlToLgeImage =(source:string) => source.replace('_sml.','_lge.')

export const prefixImageHttps = (source: string) =>
source.substr(0,2) == '//' ? `https:${source}` : source

                                      
